/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetInventorySectionCompletenessResponse } from './AssetInventorySectionCompletenessResponse';
import {
    AssetInventorySectionCompletenessResponseFromJSON,
    AssetInventorySectionCompletenessResponseFromJSONTyped,
    AssetInventorySectionCompletenessResponseToJSON,
    AssetInventorySectionCompletenessResponseToJSONTyped,
} from './AssetInventorySectionCompletenessResponse';

/**
 * 
 * @export
 * @interface AssetInventoryCompletenessResponse
 */
export interface AssetInventoryCompletenessResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetInventoryCompletenessResponse
     */
    clientId: string;
    /**
     * 
     * @type {Array<AssetInventorySectionCompletenessResponse>}
     * @memberof AssetInventoryCompletenessResponse
     */
    sections: Array<AssetInventorySectionCompletenessResponse>;
}

/**
 * Check if a given object implements the AssetInventoryCompletenessResponse interface.
 */
export function instanceOfAssetInventoryCompletenessResponse(value: object): value is AssetInventoryCompletenessResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('sections' in value) || value['sections'] === undefined) return false;
    return true;
}

export function AssetInventoryCompletenessResponseFromJSON(json: any): AssetInventoryCompletenessResponse {
    return AssetInventoryCompletenessResponseFromJSONTyped(json, false);
}

export function AssetInventoryCompletenessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetInventoryCompletenessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'sections': ((json['sections'] as Array<any>).map(AssetInventorySectionCompletenessResponseFromJSON)),
    };
}

export function AssetInventoryCompletenessResponseToJSON(json: any): AssetInventoryCompletenessResponse {
    return AssetInventoryCompletenessResponseToJSONTyped(json, false);
}

export function AssetInventoryCompletenessResponseToJSONTyped(value?: AssetInventoryCompletenessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'sections': ((value['sections'] as Array<any>).map(AssetInventorySectionCompletenessResponseToJSON)),
    };
}

